import {Component, OnInit, ViewChild, OnDestroy, ViewContainerRef, ComponentRef} from '@angular/core';
import {NgProgress} from 'ngx-progressbar';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import {BreadcrumbComponent} from '../breadcrumb/breadcrumb.component';
import {IMenu} from '../models/imenu.model';
import {QuoteService} from '../services/quote.service';
import {AuthService} from '../services/auth.service';
import {filter, takeUntil} from 'rxjs/operators';
import { NgProgressService } from '../services/ngProgress.service';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-quotes',
  templateUrl: './quotes.component.html',
  styleUrls: ['./quotes.component.css']
})
export class QuotesComponent implements OnInit, OnDestroy {

  Menu: IMenu[] = [
    {
      menuName: 'Open Quotes',
      menuRouter: 'openQuotes'
    },
    {
      menuName: ' Recently Expired Quotes',
      menuRouter: 'expiredQuotes'
    },
    {
      menuName: 'Price List',
      menuRouter: 'pricelist'
    }
  ];

  MENULIST: IMenu[] = [];

  title = 'Quotes';
  created = false;

  // the component can be any instance of the child component in the second menu
  component: ComponentRef<any>;

  @ViewChild('entry', {read: ViewContainerRef}) entry: ViewContainerRef;
  @ViewChild(BreadcrumbComponent) breadcrumbRef: BreadcrumbComponent; //reference to the breadcrumb


  filterInput: string;
  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
    private ngProgress: NgProgressService,
    private quoteService: QuoteService,
    private authService: AuthService
  ) {
  }

  ngOnInit() {
    this.ngProgress.start();
    //detect route changes, and slide to buy component.
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(res => {
      this.breadcrumbRef.ngAfterViewInit();
    });
    this.activeRouter.url.subscribe(value => {
      if (value.length === 0) {
        $('#levelOne').animate({scrollLeft: 0}, 400);
      }
    });
    this.router.events.pipe(
      takeUntil(this.ngUnsubscribe),
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      if (this.router.url === '/quotes') {
        $('#levelOne').animate({scrollLeft: 0}, 400);
      }

    });
    this.authService.getLoginInfo().subscribe((user) => {
      if (user.isStaffAccount) {
        this.MENULIST = this.Menu;
      } else {
        this.MENULIST = this.Menu.slice(0, 2);
      }
    });

  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  search(field: string) {
    if (field.length === 0) {
      return;
    }
    this.quoteService.monitorSearchKeyWordChange(field);
    this.router.navigateByUrl('/quotes/expiredQuotes');
  }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }

  close() {
    this.entry.clear();
    this.created = false;
  }
}
